<template>
  <div id="entire_app__ticket_scanner_dashboard">
    <div
      v-if="$store.state.SidebarToggle.loadingPageData"
      :class="{
        '--booking_in_progress': $store.state.SidebarToggle.loadingPageData,
      }"
      class="ticket_booking_order"
    >
      <div class="ticking_procedure_background loading_data_background"></div>
      <div class="error_occurred_container">
        <div class="alert_container loading_container col-mob-11">
          <img class="logo col-mob-5" src="../../assets/logo.png" alt="" />
          <img class="loader" src="../../assets/loading.gif" alt="" />
        </div>
      </div>
    </div>
    <div class="navigation_container">
      <div class="logo_container">
        <img src="../../assets/logo.png" alt="logo" />
      </div>
      <div class="icon_container">
        <div class="expand_to_maximum icon_cont" @click="navigateTo('help')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355z"
            />
          </svg>
        </div>
        <div class="settings icon_cont" @click="navigateTo('settings')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M2.213 14.06a9.945 9.945 0 0 1 0-4.12c1.11.13 2.08-.237 2.396-1.001.317-.765-.108-1.71-.986-2.403a9.945 9.945 0 0 1 2.913-2.913c.692.877 1.638 1.303 2.403.986.765-.317 1.132-1.286 1.001-2.396a9.945 9.945 0 0 1 4.12 0c-.13 1.11.237 2.08 1.001 2.396.765.317 1.71-.108 2.403-.986a9.945 9.945 0 0 1 2.913 2.913c-.877.692-1.303 1.638-.986 2.403.317.765 1.286 1.132 2.396 1.001a9.945 9.945 0 0 1 0 4.12c-1.11-.13-2.08.237-2.396 1.001-.317.765.108 1.71.986 2.403a9.945 9.945 0 0 1-2.913 2.913c-.692-.877-1.638-1.303-2.403-.986-.765.317-1.132 1.286-1.001 2.396a9.945 9.945 0 0 1-4.12 0c.13-1.11-.237-2.08-1.001-2.396-.765-.317-1.71.108-2.403.986a9.945 9.945 0 0 1-2.913-2.913c.877-.692 1.303-1.638.986-2.403-.317-.765-1.286-1.132-2.396-1.001zM4 12.21c1.1.305 2.007 1.002 2.457 2.086.449 1.085.3 2.22-.262 3.212.096.102.195.201.297.297.993-.562 2.127-.71 3.212-.262 1.084.45 1.781 1.357 2.086 2.457.14.004.28.004.42 0 .305-1.1 1.002-2.007 2.086-2.457 1.085-.449 2.22-.3 3.212.262.102-.096.201-.195.297-.297-.562-.993-.71-2.127-.262-3.212.45-1.084 1.357-1.781 2.457-2.086.004-.14.004-.28 0-.42-1.1-.305-2.007-1.002-2.457-2.086-.449-1.085-.3-2.22.262-3.212a7.935 7.935 0 0 0-.297-.297c-.993.562-2.127.71-3.212.262C13.212 6.007 12.515 5.1 12.21 4a7.935 7.935 0 0 0-.42 0c-.305 1.1-1.002 2.007-2.086 2.457-1.085.449-2.22.3-3.212-.262-.102.096-.201.195-.297.297.562.993.71 2.127.262 3.212C6.007 10.788 5.1 11.485 4 11.79c-.004.14-.004.28 0 .42zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            />
          </svg>
        </div>
        <div class="client_potal icon_cont" @click="navigateTo('client')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M12 2c3.5 0 6 3 7 6 3 1 4 3.73 4 6l-2.775.793a1 1 0 0 0-.725.961v1.496A1.75 1.75 0 0 1 17.75 19h-.596a2 2 0 0 0-1.668.896C14.558 21.3 13.396 22 12 22c-1.396 0-2.558-.701-3.486-2.104A2 2 0 0 0 6.846 19H6.25a1.75 1.75 0 0 1-1.75-1.75v-1.496a1 1 0 0 0-.725-.961L1 14c0-2.266 1-5 4-6 1-3 3.5-6 7-6zm0 2C9.89 4 7.935 5.788 6.989 8.371l-.092.261-.316.95-.949.315c-1.255.419-2.067 1.341-2.424 2.56l-.023.086 1.14.327a3 3 0 0 1 2.17 2.703l.005.181V17h.346a4 4 0 0 1 3.2 1.6l.136.192C10.758 19.663 11.316 20 12 20c.638 0 1.167-.293 1.703-1.04l.115-.168a4 4 0 0 1 3.1-1.785l.236-.007h.346v-1.246a3 3 0 0 1 2.003-2.83l.173-.054 1.139-.327-.023-.087c-.337-1.151-1.08-2.037-2.22-2.484l-.204-.075-.95-.316-.315-.949C16.195 5.91 14.18 4 12 4zm0 8c.828 0 1.5 1.12 1.5 2.5S12.828 17 12 17s-1.5-1.12-1.5-2.5.672-2.5 1.5-2.5zM9.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
            />
          </svg>
        </div>
        <div class="account_picture">
          <div class="arrow_logout" @click="logout">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="18"
                height="18"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  fill="#ffffff"
                  d="M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z"
                />
              </svg>
            </span>
            <span>
              <p>logout</p>
            </span>
          </div>
          <div class="image">
            <img
              v-if="$store.state.UserDetails.user.photo == ''"
              src="../../assets/default.png"
              alt="avatar"
            />
            <img
              v-else
              :src="$store.state.UserDetails.user.photo"
              alt="avatar"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content_container col-mob-12">
      <div class="scanner_container">
        <h2>Scan bookinga ticket Qr code</h2>
        <div class="options col-mob-12">
          <div class="options_content">
            <div
              class="option"
              :class="{ option_active: current_reader == 'stream' }"
              @click="changeReader('stream')"
            >
              <p>Stream</p>
            </div>
            <div
              class="option"
              :class="{ option_active: current_reader == 'capture' }"
              @click="changeReader('capture')"
            >
              <p>Capture</p>
            </div>
            <div
              class="option"
              :class="{ option_active: current_reader == 'drop' }"
              @click="changeReader('drop')"
            >
              <p>Drop qr</p>
            </div>
          </div>
        </div>
        <div class="scanner col-mob-12">
          <div class="results col-mob-11" v-if="current_reader == 'results'">
            <div class="valid_ticket" v-if="current_reader_status == 'valid'">
              <img src="../../assets/valid.gif" alt="" />
              <h2>Valid Bookinga Ticket</h2>
              <p>Ticket by {{ names }} on Bus {{ busplate }}</p>
              <span>Valid till {{ date }} at {{ time }} hrs</span>
              <button @click="changeReader('stream')">
                Scan again
              </button>
            </div>
            <div
              class="invalid_ticket"
              v-if="current_reader_status == 'invalid'"
            >
              <img src="../../assets/cross.gif" alt="" />
              <h2>Invalid Ticket Noticed</h2>
              <p>{{ invalid_ticket_msg }}</p>
              <span>Not currently allowed!</span>
              <button @click="changeReader('stream')">
                Scan again
              </button>
            </div>
          </div>
          <div class="stream col-mob-11" v-if="current_reader == 'stream'">
            <qr-stream @decode="onDecode" class="mb">
              <div style="color: red;" class="frame"></div>
            </qr-stream>
          </div>
          <div class="capture col-mob-11" v-if="current_reader == 'capture'">
            <div class="guide">
              <h2>Click and Select Qrcode Image</h2>
              <p>If you have you ticket qrcode as an image use this.</p>
            </div>
            <qr-capture @decode="onDecode" class="mb"></qr-capture>
          </div>
          <div class="drop col-mob-11" v-if="current_reader == 'drop'">
            <div class="guide">
              <h2>Drag and Drop Qrcode Image</h2>
              <p>If you have you ticket qrcode as an image use this.</p>
            </div>
            <qr-dropzone class="dropzone mb" @decode="onDecode"></qr-dropzone>
          </div>
        </div>
        <button @click="reloadPage">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="20"
            height="20"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              fill="#ffffff"
              d="M18.537 19.567A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10c0 2.136-.67 4.116-1.81 5.74L17 12h3a8 8 0 1 0-2.46 5.772l.997 1.795z"
            />
          </svg>
          &nbsp;&nbsp; Restart my scanner
        </button>
        <span>
          Please, click the refresh button above if problems
        </span>
      </div>
      <div class="recent_ticket_scans col-mob-12">
        <div class="stats_container">
          <h4>Current provider statistics</h4>
          <div class="stats_content">
            <div
              class="stat_box"
              style="border: 1.5px solid #2E86C1; background: #2E86C1"
            >
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    fill="#f1f1f1"
                    d="M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1h1zm5 4h-4v-2h2v-2h2v4zM3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm13-2h3v2h-3v-2zM6 6h2v2H6V6zm0 10h2v2H6v-2zM16 6h2v2h-2V6z"
                  />
                </svg>
              </div>
              <div class="details">
                <p>All scans</p>
                <h2 v-if="!$store.state.Provider.loadingData">
                  {{ $store.state.Provider.all_scans }}
                </h2>
                <h3 v-if="$store.state.Provider.loadingData">loading . . .</h3>
              </div>
            </div>
            <div
              class="stat_box"
              style="border: 1.5px solid #28B463; background: #28B463"
            >
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    fill="#f1f1f1"
                    d="M5.671 4.257L13.414 12 12 13.414 8.554 9.968a4 4 0 1 0 3.697-1.96l-1.805-1.805a6 6 0 1 1-3.337 2.32L5.68 7.094a8 8 0 1 0 3.196-2.461L7.374 3.132A9.957 9.957 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12a9.98 9.98 0 0 1 3.671-7.743z"
                  />
                </svg>
              </div>
              <div class="details">
                <p>All valid scans</p>
                <h2 v-if="!$store.state.Provider.loadingData">
                  {{ $store.state.Provider.all_valid_scans }}
                </h2>
                <h3 v-if="$store.state.Provider.loadingData">loading . . .</h3>
              </div>
            </div>
            <div
              class="stat_box"
              style="border: 1.5px solid #CB4335; background: #CB4335"
            >
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    fill="#f1f1f1"
                    d="M2 4h2v16H2V4zm4 0h1v16H6V4zm2 0h2v16H8V4zm3 0h2v16h-2V4zm3 0h2v16h-2V4zm3 0h1v16h-1V4zm2 0h3v16h-3V4z"
                  />
                </svg>
              </div>
              <div class="details">
                <p>All invalid scans</p>
                <h2 v-if="!$store.state.Provider.loadingData">
                  {{ $store.state.Provider.all_invalid_scans }}
                </h2>
                <h3 v-if="$store.state.Provider.loadingData">loading . . .</h3>
              </div>
            </div>
            <div
              class="stat_box"
              style="border: 1.5px solid #138D75; background: #138D75"
            >
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    fill="#f1f1f1"
                    d="M15 3h6v5h-2V5h-4V3zM9 3v2H5v3H3V3h6zm6 18v-2h4v-3h2v5h-6zm-6 0H3v-5h2v3h4v2zM3 11h18v2H3v-2z"
                  />
                </svg>
              </div>
              <div class="details">
                <p>Today's scans</p>
                <h2 v-if="!$store.state.Provider.loadingData">
                  {{ $store.state.Provider.today_scans }}
                </h2>
                <h3 v-if="$store.state.Provider.loadingData">loading . . .</h3>
              </div>
            </div>
            <div
              class="stat_box"
              style="border: 1.5px solid #17A589; background: #17A589"
            >
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                >
                  <path fill="none" d="M0 0H24V24H0z" />
                  <path
                    fill="#f1f1f1"
                    d="M13.196 2.268l3.25 5.63c.276.477.112 1.089-.366 1.365l-1.3.75 1.001 1.732-1.732 1-1-1.733-1.299.751c-.478.276-1.09.112-1.366-.366L8.546 8.215C6.494 8.837 5 10.745 5 13c0 .625.115 1.224.324 1.776C6.1 14.284 7.016 14 8 14c1.684 0 3.174.833 4.08 2.109l7.688-4.439 1 1.732-7.878 4.549c.072.338.11.69.11 1.049 0 .343-.034.677-.1 1H21v2l-17 .001c-.628-.836-1-1.875-1-3.001 0-1.007.298-1.945.81-2.73C3.293 15.295 3 14.182 3 13c0-2.995 1.881-5.551 4.527-6.55l-.393-.682c-.552-.957-.225-2.18.732-2.732l2.598-1.5c.957-.552 2.18-.225 2.732.732zM8 16c-1.657 0-3 1.343-3 3 0 .35.06.687.17 1h5.66c.11-.313.17-.65.17-1 0-1.657-1.343-3-3-3zm3.464-12.732l-2.598 1.5 2.75 4.763 2.598-1.5-2.75-4.763z"
                  />
                </svg>
              </div>
              <div class="details">
                <p>Today's valid</p>
                <h2 v-if="!$store.state.Provider.loadingData">
                  {{ $store.state.Provider.today_valid_scans }}
                </h2>
                <h3 v-if="$store.state.Provider.loadingData">loading . . .</h3>
              </div>
            </div>
            <div
              class="stat_box"
              style="border: 1.5px solid #BA4A00; background: #BA4A00"
            >
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    fill="#f1f1f1"
                    d="M19 9h-5V4H5v7.857l1.5 1.393L10 9.5l3 5 2-2.5 3 3-3-.5-2 2.5-3-4-3 3.5-2-1.25V20h14V9zm2-1v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8z"
                  />
                </svg>
              </div>
              <div class="details">
                <p>Today's invalid</p>
                <h2 v-if="!$store.state.Provider.loadingData">
                  {{ $store.state.Provider.today_invalid_scans }}
                </h2>
                <h3 v-if="$store.state.Provider.loadingData">loading . . .</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="recent_scans_container">
          <h4>Recent scanned tickets</h4>
          <div class="recent_scan">
            <p
              v-if="
                $store.state.Provider.recent_scans.length <= 0 &&
                  !$store.state.Provider.loadingData
              "
              style="font-family:satoshi, $poppins;
							font-size: 0.85em;
							font-weight: 600;
							color: $mainDark;
							opacity: 0.6;"
            >
              No recent scans yet
            </p>

            <p
              v-if="
                $store.state.Provider.recent_scans.length == 0 &&
                  $store.state.Provider.loadingData
              "
              style="font-family:satoshi, $poppins;
							font-size: 0.85em;
							font-weight: 600;
							color: $mainDark;
							opacity: 0.6;"
            >
              loading . . .
            </p>

            <div
              class="scan_box"
              v-for="(recent, index) in $store.state.Provider.recent_scans"
              :key="index"
            >
              <div class="num">
                <p>0{{ index + 1 }}.</p>
              </div>
              <div class="details">
                <div class="names">
                  <div class="user col-mob-8">
                    <p>{{ recent.name }}</p>
                  </div>
                  <div class="bus col-mob-4">
                    <p>{{ recent.busplate }}</p>
                  </div>
                  <div class="seats">
                    <p>1 seat</p>
                  </div>
                  <div class="date">
                    <p>{{ recent.date }}</p>
                  </div>
                </div>
                <div class="loc_time">
                  <div class="journey">
                    <p>
                      {{ recent.departure }}
                      &nbsp;&nbsp;<svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                          d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                        /></svg
                      >&nbsp;&nbsp;
                      {{ recent.destination }}
                    </p>
                  </div>
                  <div class="time">
                    <p>{{ recent.time }} Hrs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router/index";
import { QrStream, QrCapture, QrDropzone } from "vue3-qr-reader";
import axios from "axios";
import urlB64ToUint8Array from "urlb64touint8array";

export default {
  name: "ProviderDashboard",

  components: {
    QrStream,
    QrCapture,
    QrDropzone,
  },

  data() {
    return {
      currentuser: new String(),
      current_reader: "stream",
      current_reader_status: "",
      names: "",
      busplate: "",
      time: "",
      date: "",
      invalid_ticket_msg: "",
      departure: "",
      destination: "",
    };
  },

  methods: {
    onDecode(decodedata) {
      if (decodedata == null || decodedata == undefined) {
        this.current_reader = "results";
        this.current_reader_status = "invalid";
        this.invalid_ticket_msg = "Unable to fetch qrcode data!";
        this.$store.commit("Provider/addNumberScansData", "invalid");
        return;
      } else {
        var ticket_id = decodedata.split("*")[0];
        this.busplate = decodedata.split("*")[3];
        this.date = decodedata.split("*")[4];
        this.names = decodedata.split("*")[7];
        this.time = decodedata.split("*")[9];
        this.departure = decodedata.split("*")[5];
        this.destination = decodedata.split("*")[6];

        let currentScan = {
          name: this.names,
          busplate: this.busplate,
          date: this.date,
          departure: this.departure,
          destination: this.destination,
          time: this.time,
        };

        if (ticket_id == null || ticket_id == undefined || ticket_id == "") {
          this.current_reader = "results";
          this.current_reader_status = "invalid";
          this.invalid_ticket_msg = "Qrcode has incorrect data!";
          this.$store.commit("Provider/addNumberScansData", "invalid");
          return;
        } else {
          var config = {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwt"),
            },
          };

          let __check_scan_ticket =
            "https://bookinga.herokuapp.com/api/v1/ticket/scanning";
          let ticket_scan_data = {
            ticketId: ticket_id,
          };
          axios
            .post(`${__check_scan_ticket}`, ticket_scan_data, config)
            .then(() => {
              this.current_reader = "results";
              this.current_reader_status = "valid";
              this.$store.commit("Provider/addNumberScansData", "valid");
              this.$store.commit("Provider/addNewRecentScan", currentScan);
            })
            .catch((err) => {
              this.invalid_ticket_msg = err.response.data.message;
              this.current_reader = "results";
              this.current_reader_status = "invalid";
              this.$store.commit("Provider/addNumberScansData", "invalid");
              this.$store.commit("Provider/addNewRecentScan", currentScan);
            });
        }
      }
    },
    changeReader(value) {
      this.current_reader = value;
    },
    reloadPage() {
      location.reload();
    },
    navigateTo(val) {
      if (val == "settings") {
        router.push("/profile");
      } else if (val == "client") {
        router.push("/dashboard");
      } else if (val == "help") {
        router.push("/contactUs");
      } else {
        router.push("/provider");
      }
    },
    logout() {
      localStorage.removeItem("jwt");
      router.push("/");
    },
    checkIfLoadingIsDone() {
      if (
        this.$store.state.UserDetails.user.firstname != undefined &&
        this.$store.state.UserDetails.user.firstname != null &&
        this.$store.state.UserDetails.user != []
      ) {
        this.$store.commit("SidebarToggle/updateLoadingNumber");
      } else {
        let checkInter = setInterval(() => {
          if (
            this.$store.state.UserDetails.user.firstname != undefined &&
            this.$store.state.UserDetails.user.firstname != null &&
            this.$store.state.UserDetails.user != []
          ) {
            this.$store.commit("SidebarToggle/updateLoadingNumber");
            clearInterval(checkInter);
          }
        }, 3000);
      }
    },
  },

  // created() {
  //     var userDataToDisplay = this.$store.state.UserDetails.user.data
  //     Object.assign(this.user, userDataToDisplay)
  // },

  computed: {
    user() {
      var userDataToDisplay = this.$store.state.UserDetails.user;
      return Object.assign(this.currentuser, userDataToDisplay);
    },
  },

  mounted() {
    // this.$store.dispatch.userData("getUser")
    this.$store.dispatch("UserDetails/getUser");
    this.$store.commit("Provider/getAllStoredData");
    this.checkIfLoadingIsDone();

    //enabling notifications
    let swRegistration;
    if ("serviceWorker" in navigator && "PushManager" in window) {
      console.log("Service Worker and Push is supported");

      navigator.serviceWorker
        .register("./sw.js")
        .then(function(swReg) {
          console.log("Service Worker is registered", swReg);

          swRegistration = swReg;
          console.warn(swReg);

          const applicationServerPublicKey =
            "BDtoPBbV0fhOH4NBN1gyCXre2k0AuxjdtXLJBhuH_yxLGCGrx6Ly2qCUYcr6NlPq04JocA7QxKS_mYx_7-VvgoA";

          const applicationServerKey = urlB64ToUint8Array(
            applicationServerPublicKey
          );
          swRegistration.pushManager
            .subscribe({
              userVisibleOnly: true,
              applicationServerKey: applicationServerKey,
            })
            .then(function(subscription) {
              console.log("User is subscribed.");
              console.warn(subscription);
            })
            .catch(function(err) {
              console.log("Failed to subscribe the user: ", err);
            });
        })
        .catch(function(error) {
          console.error("Service Worker Error", error);
        });
    } else {
      console.warn("Push messaging is not supported");
      pushButton.textContent = "Push Not Supported";
    }
  },
};
</script>

<style lang="scss" scoped>
#entire_app__ticket_scanner_dashboard {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;

  .--booking_in_progress {
    display: block !important;
  }

  .ticket_booking_order {
    position: absolute;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 999;
    display: none;
    transition: all 0.5s ease;

    .ticking_procedure_background {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: $dimestDark;
      opacity: 0.55;
    }

    .loading_data_background {
      background-color: $pureWhite !important;
      opacity: 1 !important;
    }

    .error_occurred_container {
      width: 100%;
      height: 100vh;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;

      .loading_container {
        flex-direction: column;
        .logo {
          width: 30%;
        }

        .loader {
          width: 10%;
          margin-top: 2em;
        }
      }

      .alert_container {
        position: fixed;
        background-color: $pureWhite;
        width: 40%;
        height: auto;
        min-height: 28% !important;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.5s ease !important;
        padding: 0.2em;

        .error_image {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30%;
          height: 100%;

          img {
            width: 85%;
            height: auto;
          }
        }
      }
    }

    .ticket_booking_procedure_container {
      width: 100%;
      height: 100%;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;

      .procedure_form {
        position: fixed;
        background-color: $pureWhite;
        width: 35%;
        height: auto;
        min-height: 80%;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.5s ease !important;
      }
    }
  }

  .navigation_container {
    width: 100%;
    height: 8vh;
    border-bottom: 1.5px solid rgba(35, 35, 39, 0.041);
    display: flex;

    .logo_container {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;

      img {
        margin-left: 15%;
        margin-top: 0.3em;
        width: auto;
        height: 75%;
      }
    }

    .icon_container {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .icon_cont {
        width: 3em;
        height: 3em;
        margin: auto 0.2em;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          fill: $dimerDark;
          cursor: pointer;
        }
      }

      .account_picture {
        margin-right: 15%;
        display: flex;
        align-items: center;
        width: auto;
        height: 100%;

        .image {
          width: 3em;
          height: 3em;
          border-radius: 50%;
          background: $notificationSide;
          padding: 0.18em;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            border-radius: 50%;
            width: 100%;
            height: auto;
          }
        }

        .arrow_logout {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          overflow: hidden;
          transition: all 0.2s ease;
          width: 2.8em;
          height: 2.3em;
          margin-right: -0.5em;
          border-top-left-radius: 0.8em;
          border-bottom-left-radius: 0.8em;
          background: $mainBlue;
          cursor: pointer;

          span {
            svg {
              margin-top: -0.25em;
            }

            p {
              font-family: satoshi, $poppins;
              font-size: 0.86em;
              font-weight: 500;
              color: $pureWhite;
              display: none;
            }
          }
        }

        .arrow_logout:hover {
          width: 6em;

          span {
            p {
              display: flex;
            }
          }
        }
      }
    }
  }

  .content_container {
    width: 100%;
    height: 90vh;
    display: flex;
    padding-left: 8%;
    padding-right: 8%;

    .scanner_container {
      width: 50%;
      height: 70vh;

      h2 {
        font-family: satoshi, $poppins;
        font-size: 1.2em;
        font-weight: 600;
        color: $mainDark;
        margin: 1em 0;
        opacity: 0.7;
      }

      .options {
        height: 8vh;
        width: 25em;
        display: flex;
        align-items: center;

        .options_content {
          width: 100%;
          height: 85%;
          border-radius: 0.3em;
          overflow: hidden;
          background: $notificationSide;
          display: flex;

          .option {
            width: 33.3%;
            height: 100%;
            border: 1px solid rgba(35, 35, 39, 0.041);
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            p {
              font-size: 0.87em;
              font-weight: 500;
              color: $dimerDark;
            }
          }

          .option_active {
            background: $mainBlue !important;

            p {
              color: $pureWhite;
            }
          }
        }
      }

      .scanner {
        width: 25em;
        height: 25em;
        background: $notificationSide;
        border-radius: 0.25em;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.4em;

        .drop,
        .stream,
        .capture,
        .results {
          width: 90%;
          height: 90%;
          border-radius: 0.3em;
          overflow: hidden;
        }

        .results {
          display: flex;
          justify-content: center;
          align-items: center;

          .invalid_ticket {
            h2 {
              color: $mainRed !important;
            }
          }

          .valid_ticket,
          .invalid_ticket {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background: $pureWhite;

            img {
              width: 8em;
              height: auto;
            }

            h2 {
              color: $mainDark;
              opacity: 0.6;
              font-family: $poppins;
            }

            p {
              color: $mainDark;
              opacity: 0.4;
              font-size: 0.85em;
              font-family: $poppins;
            }

            span {
              color: $mainDark;
              opacity: 0.2;
              margin-top: 0.5em;
              font-size: 0.78em;
              font-family: $poppins;
            }

            button {
              background: $mainGreen !important;
              cursor: pointer;
            }
          }
        }

        .capture,
        .drop {
          border: 2px solid rgba(35, 35, 39, 0.089);
          border-style: dashed;
          position: relative;

          .guide {
            width: 100%;
            height: 100%;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            h2 {
              text-align: center;
              font-size: 1.2em;
              color: $mainDark;
              font-family: $poppins;
            }

            p {
              font-size: 0.83em;
              color: $mainDark;
              opacity: 0.5;
            }
          }

          input,
          .dropzone {
            opacity: 0;
            width: 100%;
            height: 100%;
            z-index: 5;
          }
        }
      }

      button {
        font-family: satoshi, $poppins;
        font-size: 0.89em;
        font-weight: 500;
        color: $pureWhite;
        background: $mainBlue;
        margin: 1em 0 0.8em 0;
        border-radius: 0.25em;
        padding: 0.85em 3em;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: none;
      }

      span {
        font-family: satoshi, $poppins;
        font-size: 0.83em;
        font-weight: 500;
        opacity: 0.4;
      }
    }

    .recent_ticket_scans {
      width: 50%;
      height: 70vh;

      .stats_container,
      .recent_scans_container {
        width: 100%;
        height: auto;

        h4 {
          font-family: satoshi, $poppins;
          font-size: 1.2em;
          font-weight: 600;
          color: $mainDark;
          margin: 1em 0;
          opacity: 0.7;
        }

        .stats_content,
        .recent_scan {
          width: 100%;
          height: auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .stat_box {
            width: 32%;
            height: 12vh;
            margin-bottom: 0.8em;
            border-radius: 0.3em;
            display: flex;

            .icon {
              width: 30%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .details {
              width: 70%;
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;

              p {
                font-family: satoshi, $poppins;
                font-size: 0.87em;
                font-weight: 600;
                color: $pureWhite;
                opacity: 0.8;
                margin-bottom: 0.4em;
              }

              h2 {
                font-family: satoshi, $poppins;
                font-size: 1.2em;
                font-weight: 600;
                color: $pureWhite;
              }

              h3 {
                font-family: satoshi, $poppins;
                font-size: 0.9em;
                font-weight: 600;
                color: $pureWhite;
                opacity: 0.7;
              }
            }
          }

          .scan_box {
            width: 100%;
            height: 10vh;
            background: $notificationSide;
            border: 1.5px solid rgba(0, 0, 0, 0.1);
            margin-bottom: 0.5em;
            border-radius: 0.3em;
            display: flex;

            .num {
              height: 100%;
              width: 10%;
              display: flex;
              justify-content: center;
              align-items: center;

              p {
                font-family: satoshi, $poppins;
                font-size: 0.86em;
                font-weight: 600;
                color: $mainDark;
                margin: 1em 0;
                opacity: 0.6;
              }
            }

            .details {
              height: 100%;
              width: 90%;

              .names {
                width: 100%;
                height: 50%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .user,
                .seats,
                .date,
                .bus {
                  margin-top: 1em;

                  p {
                    font-family: satoshi, $poppins;
                    font-size: 0.86em;
                    font-weight: 600;
                    color: $mainDark;
                  }
                }

                .bus {
                  width: 20%;
                  height: 100%;
                  p {
                    opacity: 0.6;
                  }
                }

                .user {
                  width: 45%;
                  height: 100%;

                  p {
                    font-size: 0.88em !important;
                    opacity: 0.8;
                  }
                }

                .seats {
                  width: 15%;
                  height: 100%;
                  p {
                    opacity: 0.5;
                  }
                }

                .date {
                  width: 20%;
                  height: 100%;
                  p {
                    opacity: 0.6;
                  }
                }
              }

              .loc_time {
                width: 100%;
                height: 50%;
                display: flex;
                align-items: center;

                .journey,
                .time {
                  margin-top: 0.3em;
                  p {
                    font-family: satoshi, $poppins;
                    font-size: 0.86em;
                    font-weight: 600;
                    color: $mainDark;
                  }
                }

                .journey {
                  width: 80%;
                  height: 100%;
                  p {
                    font-size: 0.88em !important;
                    opacity: 0.6;
                  }
                }

                .time {
                  width: 20%;
                  height: 100%;
                  p {
                    opacity: 0.6;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  #entire_app__ticket_scanner_dashboard {
    min-height: 100vh;
    height: auto;
    overflow-y: scroll;

    .ticket_booking_order {
      .ticket_booking_procedure_container {
        .procedure_form {
          width: 92%;
        }
      }
    }

    .navigation_container {
      position: fixed;
      background: $pureWhite;
      z-index: 9;

      .logo_container {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;

        img {
          margin-left: 2%;
          height: 65%;
        }
      }

      .icon_container {
        .account_picture {
          margin-right: 2%;
        }

        .expand_to_maximum {
          display: none;
        }
      }
    }

    .content_container {
      padding-left: 0;
      padding-right: 0;
      flex-wrap: wrap;
      margin-top: 8vh;

      .scanner_container {
        width: 97%;
        height: 70vh;
        margin: auto;

        .scanner {
          .drop,
          .stream,
          .capture,
          .results {
            width: 95%;
            height: 95%;
          }
        }
      }

      .recent_ticket_scans {
        margin-top: 2em;

        .stats_container,
        .recent_scans_container {
          margin: auto;
          width: 97%;

          .stats_content,
          .recent_scan {
            .stat_box {
              width: 48% !important;
            }

            .scan_box {
              height: 18vh;
            }
          }
        }
      }
    }
  }
}
</style>
